<template>
  <div>
    <!--  :default-openeds="['1', '2', '3', '4', '5', '6']" -->
    <div :class="unfoldStatus === false ? 'unfoldMenuHeader' : 'newUnfoldMenuHeader'
      ">
      <a href="https://www.rakumart.com/" target="_blank" rel="noopener noreferrer"> <img :src="menuIcon" alt="" /></a>

    </div>
    <div :class="unfoldStatus === false ? 'unfoldSwitch' : 'newUnfoldSwitch'">
      <div class="unfoldSwitchContainer" @click="shrinkMenu">
        <div>
          <img src="@/assets/img/left-icon.png" alt="" v-if="unfoldStatus === false">
          <img src="@/assets/img/right-icon.png" alt="" v-else>
        </div>
        <div v-if="unfoldStatus === false">折叠面板</div>
      </div>
    </div>
    <div v-if="show">
      <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="subMenuSelect"
        :default-active="route" :collapse="unfoldStatus" :router="true" text-color="#fff" background-color="#32323C"
        :default-openeds="[
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '10',
          '11',
          '12',
          '13',
          '14',
          '15',
        ]">
        <el-submenu :index="index + 1 + ''" v-for="(item, index) in menu" :key="index" v-show="item.show">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span v-if="locale == 'zh'"> {{ item.name }}</span>
            <span v-else-if="locale == 'ja'"> {{ item.name_ja ? item.name_ja : item.name }}</span>
          </template>
          <el-menu-item-group v-for="(items, indexs) in item.child_menus" :key="indexs" v-show="items.show">
            <el-menu-item :index="items.route"
              v-if="items.route != 'pre-saleProblem' && items.route != 'productFollowUpPage' && items.route != '/productManagement' && items.route != 'inSaleList'">
              <span v-if="locale == 'zh'"> {{ items.name }} </span>
              <span v-else-if="locale == 'ja'"> {{ items.name_ja ? items.name_ja : items.name }}</span>
            </el-menu-item>
            <!-- 问题产品,商品管理，售中问题新打开一个页面 -->
            <el-menu-item @click="a_link(items.route)" v-else>
              <span v-if="locale == 'zh'"> {{ items.name }}</span>
              <span v-else-if="locale == 'ja'"> {{ items.name_ja ? items.name_ja : items.name }}</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      //   menu: [],
      show: false,
      numData: [],
    };
  },
  computed: {
    route() {

      return this.$route.meta.activeMenu;
    },
    menu() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
      let leftMenu = this.$store.state.leftMenu
      this.numData.forEach(data => {
        leftMenu.forEach(item => {
          item.child_menus.forEach(items => {
            if (items.name == data.tagName) {
              items.name += ` (${data.num})`
            }
          })
        })
      })


      return leftMenu;
    },
    locale() {
      return this.$i18n.locale
    },
    ...mapState({
      unfoldStatus: "isUnfoldMenu",
      menuIcon: "menuIconUrl",
    }) /* 推荐 */,
  },
  created() {
    this.$nextTick(() => {
      this.show = true;
    });
    this.$api.tabTotalApi.menuLeftNum().then(res => {
      this.numData = res.data

    })
  },

  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    shrinkMenu() {
      // this.unfoldStatus=!this.unfoldStatus;
      let Status = JSON.parse(JSON.stringify(this.unfoldStatus));
      Status = !Status;
      this.$store.commit("updateIsUnfoldMenu", Status);
    },
    subMenuSelect(key, keyPath) {
      //   console.log(key, keyPath);
    },
    //新打开页面
    a_link(link) {
      let url = this.$router.resolve({
        path: link,
      });
      window.open(url.href, "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
.unfoldMenuHeader {
  width: 100%;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 155px;
    height: 100px;
  }
}

.newUnfoldMenuHeader {
  width: 48px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 35px;
    height: 44px;
  }
}

.unfoldSwitch {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;

  .unfoldSwitchContainer {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    padding-bottom: 27px;
    border-bottom: 1px solid #545467;
    cursor: pointer;

    div:first-child {
      width: 24px;
      height: 24px;

      margin-right: 16px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    div:last-child {
      color: #ffffff;
      font-size: 18px;
    }
  }
}

.newUnfoldSwitch {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;

  .unfoldSwitchContainer {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    padding: 0 11px 27px;
    border-bottom: 1px solid #545467;
    cursor: pointer;

    div:first-child {
      width: 24px;
      height: 24px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

/deep/ .el-aside {
  width: 240px;
}

.el-menu-vertical-demo {
  width: auto;
  height: 100%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
}

@import "../../css/mixin";

.el-menu {
  border-right: 0;
  overflow: hidden;
}

.submenuIcon {
  width: 18px;
  margin-right: 10px;
  padding-left: 3px;
}

/deep/ .el-menu-item {
  background-color: #19254d;
}

/deep/.is-active {
  color: #fff !important;
  background-color: #036eb8 !important;
}

/deep/.el-submenu__title {
  font-size: 14px;
  padding: 0 10px !important;
  text-align: left;

  i {
    font-size: 20px;
    margin-right: 10px;
  }
}

/deep/.el-menu-item {
  text-align: left;
  padding: 0 0 0 43px !important;
  font-size: 14px;
  max-width: 230px;
}

/deep/.el-menu-item-group__title {
  display: none;
}

/deep/.el-submenu__icon-arrow {
  font-size: 14px !important;
  font-weight: 700;
  right: 7px;
}
</style>